import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withSizes from 'react-sizes';
import { translate } from 'react-i18next';

import { Query } from 'react-apollo';
import { getPlaces } from '../../apollo/graphql/map/query';
import createContext from '../../utils/format/createContext';

import getSizes from '../../utils/size';
import Plan from './Plan';
import {
  Root,
  ControlContainer,
  MapContainer,
  DetailContainer,
  ItineraryContainer
} from './styles';
import { Zoom } from './Zoom';
import { Floor } from './Floor';
import { Detail } from './Detail';
import { Itinerary } from './Itinerary';

const itineraryKeyName = 'common:plan.filter.placeholder';

class Map extends PureComponent {
  constructor(props) {
    super(props);

    const { t } = props;
    this.state = {
      selected: props.selected,
      item: {},
      floor: 0,
      zoom: 19,
      detailShowed: false,
      itineraryStart: { floor: 0, label: t(itineraryKeyName) },
      itineraryFinish: { floor: 0, label: t(itineraryKeyName) }
    };
    this.groundLevelZoom = this.state.zoom;
  }

  handleZoom = value => {
    if (this.Plan.OlMap) {
      const currentZoom = this.Plan.OlMap.getView().getZoom();

      const newZoom = currentZoom + value;
      if (newZoom <= 17 || newZoom >= 20) return;
      this.Plan.OlMap.getView().setZoom(newZoom);
      this.setState({
        zoom: newZoom
      });
    }
  };

  handleSelectItem = data => {
    const { t } = this.props;
    this.setState({
      item: data,
      detailShowed: true,
      itineraryStart: { floor: 0, label: t(itineraryKeyName) },
      itineraryFinish: { floor: 0, label: t(itineraryKeyName) }
    });
  };

  handleFloor = value => {
    const { t } = this.props;
    if (value === -1) {
      this.groundLevelZoom = this.Plan.OlMap.getView().getZoom();

      this.Plan.OlMap.getView().setZoom(20);
      this.Plan.OlMap.getView().setCenter(
        this.Plan.Ol.proj.fromLonLat([4.836029, 45.757787])
      );
    } else {
      this.Plan.OlMap.getView().setZoom(this.groundLevelZoom);
      this.Plan.OlMap.getView().setCenter(
        this.Plan.Ol.proj.fromLonLat([4.8363, 45.7587])
      );
    }

    this.setState({
      floor: value,
      item: {},
      itineraryStart: { floor: value, label: t(itineraryKeyName) },
      itineraryFinish: { floor: value, label: t(itineraryKeyName) }
    });
  };

  handleItinerary = (type, place) => {
    if (type === 'startValue') {
      this.setState({
        floor: place.floor,
        itineraryStart: place,
        item: {}
      });
    } else {
      this.setState({
        itineraryFinish: place,
        item: {}
      });
    }
  };

  handleOpenCloseDetail = bool => {
    this.setState({ detailShowed: bool });
  };

  render() {
    const { readOnly, selected, i18n } = this.props;
    const {
      itineraryStart,
      itineraryFinish,
      item,
      zoom,
      floor,
      detailShowed
    } = this.state;

    return (
      <Query query={getPlaces} context={createContext(i18n.language)}>
        {({ loading, error, data }) => {
          if (!loading && !error && data && data.getPlaces) {
            const places = data.getPlaces;
            return (
              <Root>
                <ControlContainer>
                  <Floor
                    readOnly={readOnly}
                    currentFloor={floor}
                    itineraryStart={itineraryStart}
                    itineraryFinish={itineraryFinish}
                    onChangeFloor={value => this.handleFloor(value)}
                  />
                  <Zoom
                    readOnly={readOnly}
                    onZoomClick={value => this.handleZoom(value)}
                  />
                </ControlContainer>
                <DetailContainer>
                  {!readOnly && (
                    <Detail
                      data={item}
                      isOpen={detailShowed}
                      handleOpenCloseDetail={this.handleOpenCloseDetail}
                    />
                  )}
                </DetailContainer>
                <MapContainer>
                  <Plan
                    ref={ref => (this.Plan = ref)}
                    data={places}
                    itineraryStart={itineraryStart}
                    itineraryFinish={itineraryFinish}
                    currentFloor={floor}
                    currentZoom={zoom}
                    readOnly={readOnly}
                    selectItem={item => this.handleSelectItem(item)}
                    selectedItem={item}
                    defaultSelectItem={selected}
                    updatefloor={value => this.setState({ floor: value })}
                    translator={this.props.t}
                  />
                </MapContainer>
                {!readOnly && (
                  <ItineraryContainer>
                    <Itinerary
                      data={places}
                      startValue={itineraryStart}
                      finishValue={itineraryFinish}
                      changeValue={(type, value) =>
                        this.handleItinerary(type, value)
                      }
                    />
                  </ItineraryContainer>
                )}
              </Root>
            );
          }

          return null;
        }}
      </Query>
    );
  }
}
Map.propTypes = {
  selected: PropTypes.object,
  readOnly: PropTypes.bool,
  isMobile: PropTypes.bool
};

const mapSizesToProps = getSizes;

export default translate()(withSizes(mapSizesToProps)(Map));
